import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

import './modal.scss';

import { Button } from '~shared/ui/button/button';

interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
	onOk: () => void;
	onCancel?: () => void;
	okIsDisable: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, onOk, onCancel, okIsDisable }) => {
	// Закрытие по ESC
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose();
		};

		if (isOpen) {
			document.addEventListener('keydown', handleKeyDown);
			document.body.style.overflow = 'hidden'; // Блокируем скролл
		}

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
			document.body.style.overflow = 'auto';
		};
	}, [isOpen, onClose]);

	if (!isOpen) return null;

	return createPortal(
		<div className="modal-overlay" onClick={onClose}>
			<div className="modal-content" onClick={e => e.stopPropagation()}>
				<button className="modal-close-button" onClick={onClose}>
					&times;
				</button>
				{children}
				<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '20px', gap: '12px' }}>
					<Button disabled={okIsDisable} onClick={() => onOk()} style={{ minWidth: '150px' }}>
						Ок
					</Button>
					<Button
						variant="outline"
						onClick={() => {
							onClose();
							if (onCancel) onCancel();
						}}
						style={{ minWidth: '150px' }}
					>
						Отмена
					</Button>
				</div>
			</div>
		</div>,
		document.getElementById('modal-root') as HTMLElement,
	);
};

export default Modal;
